var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-header__content"},[_vm._t("default")],2),_c('AppBackground',{attrs:{"triangles":"first"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }